import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { $currentStepFlags } from './stepModel'

export const useTitle = () => {
  const { isConfirmCodeStep, isErrorStep, isFormStep } =
    useStore($currentStepFlags)

  const title = useMemo(() => {
    if (isFormStep) return 'Основная информация'
    if (isConfirmCodeStep) return 'Последний шаг!'
    if (isErrorStep) return 'Ошибка регистрации'

    return 'Регистрация'
  }, [isConfirmCodeStep, isErrorStep, isFormStep])

  return title
}
